import dayjs from 'dayjs';
import { toTimezone } from 'common/util/Util.tsx';
import { SavedReportBean } from 'common/api/api.ts';
import { ResolveDatesResult } from './types.ts';

export function resolveDates(
    period: SavedReportBean.ReportPeriodEnum,
    start: dayjs.Dayjs | undefined,
    end: dayjs.Dayjs | undefined,
    tz?: string,
): ResolveDatesResult {
    const todayTZ = toTimezone(dayjs(), tz);

    if (period === SavedReportBean.ReportPeriodEnum.CUSTOMRANGE) {
        return {
            start: start ? start.format('YYYY-MM-DD') : todayTZ.subtract(6, 'day').format('YYYY-MM-DD'),
            end: end ? end.format('YYYY-MM-DD') : todayTZ.format('YYYY-MM-DD'),
        };
    }

    const map: Record<string, () => [dayjs.Dayjs, dayjs.Dayjs]> = {
        [SavedReportBean.ReportPeriodEnum.TODAY]: () => [todayTZ, todayTZ],
        [SavedReportBean.ReportPeriodEnum.YESTERDAY]: () => {
            const y = todayTZ.subtract(1, 'day');
            return [y, y];
        },
        [SavedReportBean.ReportPeriodEnum.LAST3DAYS]: () => [todayTZ.subtract(2, 'day'), todayTZ],
        [SavedReportBean.ReportPeriodEnum.LAST7DAYS]: () => [todayTZ.subtract(6, 'day'), todayTZ],
        [SavedReportBean.ReportPeriodEnum.LAST28DAYS]: () => [todayTZ.subtract(27, 'day'), todayTZ],
        [SavedReportBean.ReportPeriodEnum.THISMONTH]: () => [todayTZ.startOf('month'), todayTZ.endOf('month')],
        [SavedReportBean.ReportPeriodEnum.LASTMONTH]: () => {
            const prev = todayTZ.subtract(1, 'month');
            return [prev.startOf('month'), prev.endOf('month')];
        },
    };

    const fn = map[period as unknown as string];
    if (!fn) { return { start: undefined, end: undefined }; }
    const [s, e] = fn();
    return { start: s.format('YYYY-MM-DD'), end: e.format('YYYY-MM-DD') };
}
